module.exports = __webpack_public_path__ + "img/logo2.f2f3afbf.png";